/**
 * Dati iniziali del modulo "Nuovo Lead" aperto da una chat (WhatsApp, Instagram,
 * Messenger): carica le fonti dell'organizzazione se non ci sono ancora, poi usa
 * buildChatLeadInitialData (puro, in src/lib/utils/chatLeadPrefill.ts).
 * Le fonti vanno lette PRIMA di aprire il modulo: il drawer prende i dati iniziali
 * solo all'apertura.
 */

import { useCallback } from 'react';
import { useLeadSourceStore } from '@/lib/stores/leadSourceStore';
import { buildChatLeadInitialData, type ChatLeadInput } from '@/lib/utils/chatLeadPrefill';

export function useChatLeadPrefill() {
  const fetchLeadSources = useLeadSourceStore((s) => s.fetchLeadSources);
  return useCallback(async (input: Omit<ChatLeadInput, 'sources'>) => {
    if (useLeadSourceStore.getState().leadSources.length === 0) {
      try { await fetchLeadSources(); } catch { /* senza fonti il campo resta vuoto */ }
    }
    const sources = useLeadSourceStore.getState().leadSources.map((s) => ({ id: s.id, name: s.name }));
    return buildChatLeadInitialData({ ...input, sources });
  }, [fetchLeadSources]);
}
